<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("routes.supporters") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" to="/supporters/add">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <supporter-filter></supporter-filter>

    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="20"
      :loading="fetchLoading"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-sm-center">
            <v-avatar size="40">
              <v-img
                @click="showImagePreview(item.main_image)"
                class="hover-pointer"
                aspect-ratio="1"
                :src="
                  item.main_image
                    ? item.main_image.path
                    : '@/assets/imgs/user.jpg'
                "
              ></v-img>
            </v-avatar>
          </td>
          <td class="text-sm-center">{{ item.name }}</td>
          <td class="text-sm-center" :title="item.description">
            {{ item.description | truncate }}
          </td>
          <td class="toggle-spacing text-center">
            <toggle-service
              :is-edit="true"
              model-name="supporters"
              :model-id="item.id"
              field="visible"
              v-model="item.visible"
              :validate="true"
            />
          </td>
          <td class="text-sm-center">{{ item.priority }}</td>

          <td class="text-sm-center">
            <v-btn :to="`/supporters/edit/${item.slug}`" text icon>
              <v-icon small title="edit"> mdi-pencil</v-icon>
            </v-btn>
            <v-icon small title="delete" @click="handleDelete(item, index)">
              mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="text-xs-center mt-4">
      <v-pagination
        v-if="pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="handlePagination"
      ></v-pagination>
    </div>

    <global-image-preview
      :showDialog="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
  </div>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { indexSupporters, deleteSupporter } from "@/api/supporter";
import SupporterFilter from "./components/SupporterFilter";
export default {
  name: "SupportersList",
  components: {
    SupporterFilter
  },
  watch: {
    "$route.query"() {
      this.indexSupporters();
    }
  },
  data() {
    return {
      items: [],
      pagination: {},
      headers: [],
      fetchLoading: false,
      imageOverlay: false,
      currentPreviewImage: ""
    };
  },
  created() {
    this.createTableHeaders();
    this.indexSupporters();
  },
  methods: {
    indexSupporters() {
      this.fetchLoading = true;

      const queryObj = this.$route.query;
      indexSupporters(queryObj)
        .then(res => {
          this.fetchLoading = false;
          this.items = res.data.data;
          this.pagination = res.data.meta;
        })
        .catch(() => {
          this.fetchLoading = false;
        });
    },
    handleDelete({ slug }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          deleteSupporter(slug)
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
    handlePagination(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },
    createTableHeaders() {
      const headersList = [
        "profile",
        "name",
        "description",
        "visibility",
        "priority",
        "actions"
      ];
      this.headers = TableHeaders(headersList);
    }
  }
};
</script>

<style lang="scss" scoped></style>
